// extracted by mini-css-extract-plugin
module.exports = {"texteditor":"TextEditor_texteditor__3sfAI","texteditor__counter":"TextEditor_texteditor__counter__1Dx2-"};